'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Channels from '../base/channels'
import Splashscreen from '../fx/Splashscreen'
import FlowWaypoints from '../fx/FlowWaypoints'

let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--single'
        this.$btnBack = this.view.querySelector('.jsBack--url')
        // Fns
        this.configureWaypoints()
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    configureWaypoints()
    {
        const $content = this.view.querySelector('.jsContent')
        const $images = this.view.querySelectorAll('img')
        const $iframes = this.view.querySelectorAll('.iframe-container')
        const $videos = this.view.querySelectorAll('.wp-video')

        for(let i = 0; i < $images.length; i++) {
            const $image = $images[i]
            $image.classList.add('jsWaypoint--appearReveal')
            $image.setAttribute('data-offset','75%')
        }
        for(let i = 0; i < $iframes.length; i++) {
            const $iframe = $iframes[i]
            $iframe.classList.add('jsWaypoint--appearReveal')
            $iframe.setAttribute('data-offset','75%')
        }
        for(let i = 0; i < $videos.length; i++) {
            const $video = $videos[i]
            $video.classList.add('jsWaypoint--appearReveal')
            $video.setAttribute('data-offset','75%')
        }
    }

    destroy()
    {
        Channels.removeListener('launcher::exit', this.funcLaunch);
        this.splashcreen.destroy()
        this.waypoints.destroy()
    }

    enableSkin()
    {
        const $tester = this.view.querySelector('.jsWhiteSkin--toggle')
        if($tester !== null && $tester.value == '1')
        {
            Env.$html.classList.add('single--whiteUI')
        }
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
            this.waypoints = new FlowWaypoints(this.view)
        }, 200);
        this.splashcreen = new Splashscreen(this.view.querySelector('.jsSplashscreen--view'))
        this.splashcreen.unlocked()
        this.enableSkin()
        if(this.$btnBack != null) {
            this.getUrl = this.$btnBack.getAttribute('href')
            Env.$btnBackUI.setAttribute('href',this.getUrl)
        } else {
            Env.$btnBackUI.classList.add('is--hidden')
        }
    }

    intro()
    {
        const tl = new TimelineLite()
        const $title = this.view.querySelector('.jsSplashscreen--view .h1')
        const $subtitle = this.view.querySelector('.jsSplashscreen--view .description')
        const $bg = this.view.querySelector('.jsSplashscreen--view .bg')
        const $content = this.view.querySelector('.works-single .wrapper')

        tl.add([
            TweenLite.fromTo($bg , 1 , { opacity : 0 } , { opacity : 1 , ease : Cubic.easeInOut }),
        ])
        tl.add([
            TweenLite.fromTo($title , .8 , { opacity : 0 , y : 30 } , { opacity : 1, y : 0 , ease : Power4.easeOut }),
            TweenLite.fromTo($subtitle , .8 , { opacity : 0 , y : 40 } , { opacity : 1, y : 0 , ease : Power4.easeOut , delay : .1 }),
            TweenLite.fromTo($content , .8 , { opacity : 0 } , { opacity : 1 , ease : Cubic.easeOut , delay : .4 }),
        ],'-=.6')
    }


}

page = Barba.BaseView.extend({
    namespace: 'single',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;


// WEBPACK FOOTER //
// ./resources/js/view/single.js